<template>
    <div>
        <el-card class="box-card" shadow="never" style="border:0;">
            <!--<el-breadcrumb-item :to="{ name: 'index' }">首页</el-breadcrumb-item>-->
            <div slot="header" style="border-bottom:0;">
                <span style="font-size:20px;">商品管理</span>
            </div>
        <!-- 操作-->
        <!--工具条-->
        <div>
            <el-button type="primary" style="margin-bottom: 2%;margin-top: 2%" class="m-1" @click="append()"><i class="fa fa-plus"></i>&nbsp;新增</el-button>

            <el-select class="m-1" v-model="Status" placeholder="请选择" @change="getProduct" style="margin-left: 5%;">
                <el-option  key="全部" label="全部" value=""> </el-option>
                <el-option  key="激活" label="激活" value="1"> </el-option>
                <el-option  key="停用" label="停用" value="0"> </el-option>
            </el-select>

            <el-input placeholder="请输入商品名称" v-model="searchString" class="input-with-select m-1" style="width: 50%;margin-left: 5%;">
                <el-button slot="append" icon="el-icon-search" @click="getProduct"></el-button>
            </el-input>

        </div>

        <!--<div slot="header" class="clearfix" shadow="hover"
             style="border-bottom: #c2cfd6;background-color: #f0f3f5;padding: 0.75rem 1.25rem 0.75rem 1.25rem;margin-bottom: 0">
            <span>商品列表</span>
        </div>-->
        <el-table :data="items.slice((page-1)*10,page*10)" border style="width: 100%">
            <el-table-column align="center" prop="SKU" label="SKU"></el-table-column>
            <el-table-column align="center"  label="商品图片" >
                <template slot-scope="scope" >
                    <img :src="scope.row.商品图片" class="avatar" style="height: 30px;">
                </template>
            </el-table-column>
            <el-table-column align="center" prop="productName" label="商品名称"></el-table-column>
            <el-table-column align="center" prop="price" label="售价" :formatter="formatter"></el-table-column>
            <el-table-column align="center" label="状态">
                <template slot-scope="scope">
                    {{scope.row.prostatus == '1'?'激活':'停用'}}
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="250">
                <template slot-scope="scope">
                    <!-- <el-button size="mini" @click="copy(scope.row)">复制</el-button> -->
                    <el-button style="background-color: #43c291; color: #fff;" size="mini" @click="edit(scope.row)">编辑</el-button>
                    <el-button v-if="scope.row.prostatus == '1'" size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
                    <el-button v-if="scope.row.prostatus == '0'" size="mini" type="primary" @click="recovery(scope.row)">恢复</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="block" v-show="items.length>10">
            <el-pagination layout="total, prev, pager, next , jumper" :current-page="page" @current-change="table" background
                           :total="items.length"></el-pagination>
        </div>

        <div class="block">

        </div>
        </el-card>
    </div>
</template>
<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/
    import moment  from 'moment'
    import axios from 'axios'// 引入axios
    export  default{
        data(){
            return {
                items: [],
                page: 1,
                Status: '1',
                searchString: ''
            }

        },
        created(){
            if(this.$route.query.cateID){
                this.Status = '';
            }
            this.getProduct()
        },
        methods: {
            table (val) {
                this.page = val
            },
            getProduct: function () {
                this.page = 1;
                console.log(this.$route.query.cateID)
                var cateID = '';
                if (this.$route.query.cateID) {
                    cateID = this.$route.query.cateID
                }

                var params = {tenantId:this.getcookie('storeId'),Status:this.Status,cateID:cateID,proName:this.searchString};
                this.$http.get(this.productURL+"/vueFeign/product",{params:params}
                ).then(response => {
                    if (response.status === 200) {
                        var li = response.data.Data
                        if (response.data.Code === '200') {
                            for (var i = 0; i < li.length; i++) {
                                var item = li[i]
                                item['商品图片'] = this.fusionImageUrl + item.Image
                            }
                            this.items = li
                        } else {
                            this.items = []
                            this.$message.error('数据获取失败，异常：' + response.data.Meta)
                        }
                    }else{
                        this.$message.error('未找到符合条件的数据')
                        this.items = []
                    }
                },function(response){
                    this.items = []
                    this.$message({
                        showClose: true,
                        message: '网络异常',
                        type: 'error'
                    });
                })
            },
            recovery (data) {
                this.$confirm('此操作将恢复该商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    console.log(data)
//                    data.Data.ID = data.ID
//                    //data.Data.remove('ID');
//                    //data.Data.remove('Model');
//                    data.Data.Price = data.Data.Price * 100

                    var params = {tenantId:this.getcookie('storeId'),stauts:"1",productId:data.productId,sku:data.SKU};
                    this.$http.get(this.productURL+"/vueFeign/product/del",{params:params}
                    ).then(res => {
                        if (res.data.Code === '200') {
                            this.$message({
                                type: 'success',
                                message: '恢复成功!'
                            })
                            this.Status = '1'
                            this.getProduct()
                            this.fusionProUpdate(data.productId);
                        } else {
                            this.$message.error('数据获取失败，异常：' + res.data.Meta)
                        }
                    },function(response){
                        this.items = []
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'
                        });
                    })
                }).catch(() => {
                    this.$message({
                        type: 'success',
                        message: '取消恢复!'
                    })
                })
            },
            remove (data) {
                this.$confirm('此操作将删除该商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var params = {tenantId:this.getcookie('storeId'),stauts:"0",productId:data.productId,sku:data.SKU};
                    this.$http.get(this.productURL+"/vueFeign/product/del",{params:params}
                    ).then(res => {
                        if (res.data.Code === '200') {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                            this.Status = '1'
                            this.fusionProUpdate(data.productId);
                            this.getProduct()
                        } else {
                            this.$message.error('数据获取失败，异常：' + res.data.Meta)
                        }
                    },function(response){
                        this.items = []
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'
                        });
                    })
                }).catch(() => {
                    this.$message({
                        type: 'success',
                        message: '取消删除!'
                    })
                })
            },
            fusionProUpdate(proId){
                var that = this;
                axios({
                    method: 'post',
                    url: this.productURL+"/vueFeign/fusion/proUpdate?tenantId="+that.getcookie('storeId')+"&proId="+proId,
                }).then(function(response) {
                    if (response.status === 200) {
                        if (response.data.Code == '200') {

                        } else {
                            that.$message.error('数据获取失败，异常：' + response.data.Meta)
                        }
                    }
                });
            },
            append () {
                this.savecookie("button", "editPro");
                this.$router.push({path: 'editPro', query: {cmd: 'add',go:'button'}})
            },
            edit (item) {
                this.savecookie("button", "editPro");
                    this.$router.push({path: 'editPro', query: {data: item, cmd: 'edit',go:'button'}})
            },
            formatter (row, column) {
                return '¥' + (row.price / 100).toFixed(2)
            }
        }

    }

</script>


// WEBPACK FOOTER //
// pro.vue?4ec54985